import download from "./download";

const path = '/admin';

const admin = (url: string) => () => ({
  download: download(url + path),
});

export default admin;
